import { apiClient } from '@indipia/shared/api/client';
import type { ShareLink } from '@indipia/shared-features';
import type { ApiResponse } from '../types/worklog.types';

// 고객 고정 링크 조회 어댑터 — GET /schedule/sites/{siteId}/customer-share-link (현장 기준, 스케줄 없는 현장도 호출 가능).
// scheduler 패키지의 customerShareLinkApi.ts 와 같은 경로를 쓴다(에이전트 패키지끼리 서로 import 하지 않아 복제).
export async function fetchCustomerShareLink(siteId: number): Promise<ShareLink> {
  const res = await apiClient.get<ApiResponse<{ url: string; expiresNotice: string }>>(
    `/schedule/sites/${siteId}/customer-share-link`,
  );
  const { url, expiresNotice } = res.data.data;
  return { url, expiresNotice };
}
